module.exports = __webpack_public_path__ + "img/testimonios-preview.ba34a9e3.png";